<script>
import _ from 'lodash'
import VertBarChart from './VertBarChart'

const MESURE_REFDATA = {
  'DECT': {
    'name': 'DECT',
    fullname: 'Téléphone domestique sans-fil (DECT)',
    color: '#CC6600',
    order: 1
  },
  'FM_RNT': {
    'name': 'FM / RNT',
    fullname: 'FM et Radio numérique (RNT)',
    color: '#CCCC00',
    order: 2
  },
  'HF': {
    'name': 'Autres',
    fullname: 'Autres',
    color: '#2B9900',
    order: 3
  },
  'RRI': {
    'name': 'RMP',
    fullname: 'Réseau Mobile Professionnel (RMP)',
    color: '#00997D',
    order: 4
  },
  'RADARS': {
    'name': 'Radar',
    fullname: 'Radar',
    color: '#005799',
    order: 5
  },
  'TM': {
    'name': 'TM',
    fullname: 'Téléphonie Mobile (TM)',
    color: '#0800FF',
    order: 6
  },
  'TV': {
    'name': 'TV',
    fullname: 'TV',
    color: '#6600CC',
    order: 7
  },
  'WIFI': {
    'name': 'Wifi',
    fullname: 'Wifi',
    color: '#8F018F',
    order: 8
  }
}

/*
Exemple d'utilisation :

Template :
  <mesure-vert-bar-chart :chart-data="mesure.services"></mesure-vert-bar-chart>

Javascript :
import MesureVertBarChart from './components/chart/MesureVertBarChart'

//...
  components: { MesureVertBarChart },

  data () {
    return {
      mesure: {"id" : "115160","code" : "B7C22A0EA06BE4E48F12F0BA6D10E29B","typedemande" : "3", "numero" : "115160", "date" : "01/07/2014", "heure" : "15h00", "laboratoire" : "AEXPERTISE", "reference" : "115160", "adresse" : {"numero" : "6", "voie" : "Avenue de l'Ouche", "codepostal" : "21000", "commune" : "DIJON"}, "longitude" : "5.0254440000000002", "latitude" : "47.317889000000001", "milieu" : "exterieur", "environnement" : "Lieu d'habitation", "protocole" : "ANFR/DR 15-3", "hauteur" : "31,5", "emetteurs" : {"emetteur" : [{"libelle" : "Radiotéléphonie", "hauteur" : "32,0", "distance" : "365,0"}, {"libelle" : "Radiotéléphonie", "hauteur" : "33,0", "distance" : "365,0"}]}, "conformite" : "true", "mesureglobale" : "0,75", "services" : [{"libelle" : "DECT", "bande" : "1880-1900", "mesure" : "0,03", "extrapolation" : "", "limite" : "59 V/m", "servicegroupelibelle" : "DECT", "servicegroupecode" : "DECT"}, {"libelle" : "FM et Radio numérique (RNT)", "bande" : "87,5-108/174-223", "mesure" : "0,51", "extrapolation" : "", "limite" : "28 V/m", "servicegroupelibelle" : "FM et Radio numérique (RNT)", "servicegroupecode" : "FM_RNT"}, {"libelle" : "HF", "bande" : "0,1-30", "mesure" : "", "extrapolation" : "", "limite" : "28 V/m", "servicegroupelibelle" : "HF", "servicegroupecode" : "HF"}, {"libelle" : "PMR", "bande" : "30-87,5 (hors TV)", "mesure" : "0,03", "extrapolation" : "", "limite" : "28 V/m", "servicegroupelibelle" : "Réseaux Radioélectriques Indépendants (RRI)", "servicegroupecode" : "RRI"}, {"libelle" : "PMR - balises", "bande" : "108-880 (hors TV et RNT)", "mesure" : "", "extrapolation" : "", "limite" : "28 V/m", "servicegroupelibelle" : "Réseaux Radioélectriques Indépendants (RRI)", "servicegroupecode" : "RRI"}, {"libelle" : "Radar - BLR (Wimax)-LTE - FH", "bande" : "2200-6000 (hors WiFi)", "mesure" : "0,11", "extrapolation" : "", "limite" : "61 V/m", "servicegroupelibelle" : "Radars", "servicegroupecode" : "RADARS"}, {"libelle" : "Radars - balises - FH", "bande" : "960-1710", "mesure" : "", "extrapolation" : "", "limite" : "42 V/m", "servicegroupelibelle" : "Radars", "servicegroupecode" : "RADARS"}, {"libelle" : "Téléphonie mobile, bande 1800", "bande" : "1805-1880", "mesure" : "0,34", "extrapolation" : "0,24", "limite" : "58 V/m", "servicegroupelibelle" : "Téléphonie Mobile", "servicegroupecode" : "TM"}, {"libelle" : "Téléphonie mobile, bande 2100", "bande" : "2110-2170", "mesure" : "0,13", "extrapolation" : "0,08", "limite" : "61 V/m", "servicegroupelibelle" : "Téléphonie Mobile", "servicegroupecode" : "TM"}, {"libelle" : "Téléphonie mobile, bande 800", "bande" : "790-862", "mesure" : "0,12", "extrapolation" : "", "limite" : "39 V/m", "servicegroupelibelle" : "Téléphonie Mobile", "servicegroupecode" : "TM"}, {"libelle" : "Téléphonie mobile, bande 900", "bande" : "921-960", "mesure" : "0,25", "extrapolation" : "0,48", "limite" : "41 V/m", "servicegroupelibelle" : "Téléphonie Mobile", "servicegroupecode" : "TM"}, {"libelle" : "TV", "bande" : "47-68/470-790", "mesure" : "0,33", "extrapolation" : "", "limite" : "28 V/m", "servicegroupelibelle" : "TV", "servicegroupecode" : "TV"}], "rapport" : "Rapport public 3A061451-R.pdf"}
    }
  }
*/
export default VertBarChart.extend({
  name: 'mesure-vert-bar-chart',

  props: {
    title: {
      type: String,
      default: 'Répartition du champ par service'
    },
    incrustText: {
      type: Boolean,
      default: false
    },
    textAngle: {
      type: Number,
      default: 30
    },
    getRectColor: {
      type: Function,
      default: item => MESURE_REFDATA[item.code].color
    },
    getText: {
      type: Function,
      default: item => MESURE_REFDATA[item.code].name
    },
    getLegendText: {
      type: Function,
      default: item => MESURE_REFDATA[item.code].fullname
    },
    getLegendTextColor: {
      type: Function,
      default: item => MESURE_REFDATA[item.code].color
    }
  },

  computed: {
    normalizedChartData: function() {
      return this.servicesToChartData(this.chartData)
    }
  },

  methods: {
    /**
     * ∀ group : √ (∑ mesure²)
     *
     * @param services de la mesure à "convertir"
     * @return tableau de la forme [{code: 'DECT', val: 5.5}, {...}]
     **/
    servicesToChartData(services) {
      let returned = []
      let moyenne = []
      // Pour chaque groupe (DECT, etc.) : racine carrée de la somme des carrés des mesures
      _.each(services, function(groupe) {
        // on regarde si il y a une mesure et on choisi la categorie
        if (groupe.mesure !== undefined) {
          let index = 0
          if (groupe.libelle.includes('DECT')) {
            index = 0
          } else if (groupe.libelle.includes('TM')) {
            index = 5
          } else if (groupe.libelle.includes('Wifi')) {
            index = 7
          } else if (groupe.libelle.includes('Radar')) {
            index = 4
          } else if (groupe.libelle.includes('PMR')) {
            index = 3
          } else if (groupe.libelle.includes('FM – RNT')) {
            index = 1
          } else if (groupe.libelle.includes('TV')) {
            index = 6
          } else {
            index = 2
          }
          // on ajoute notre moyenne dans le tableau
          if (moyenne[index] === undefined) {
            moyenne[index] = 0
          }
          moyenne[index] += groupe.mesure * groupe.mesure
        }
      })
      // Ajout des services manquant
      let index = 0
      _.each(_.keys(MESURE_REFDATA), function(r) {
        if (_.findIndex(returned, d => (d.code === r)) < 0) {
          if (moyenne[index]) {
            returned.push({
              code: r,
              val: Math.sqrt(moyenne[index])
            })
          } else {
            returned.push({
              code: r,
              val: undefined // si on veut voir de barre on place 0 sinon undefined
            })
          }
          index++
        }
      })
      // Tri des services
      return _.sortBy(returned, [r => (MESURE_REFDATA[r.code] ? MESURE_REFDATA[r.code].order : Infinity) || Infinity])
    }
  }
})
</script>
